export const getSenderName = (loggedUser, users) => {
  return users[0]._id === loggedUser._id ? users[1].name : users[0].name;
};
export const getSenderUser = (loggedUser, users) => {
  return users[0]._id === loggedUser._id ? users[1] : users[0];
};
export const getAvatarPic = (loggedUser, users) => {
  return users[0]._id === loggedUser._id ? users[1].pic : users[0].pic;
};

export const isSameSender = (messages, message, index, userId) => {
  // console.log("message", message.sender);
  // console.log("messages", messages);
  // console.log("message", message);
  // console.log("index", index);
  // console.log("userId", userId);
  // console.log("senderid-", index < messages.length - 1?messages[index + 1].sender[0]._id : '');
  // console.log("senderid+", message.sender[0]._id);
  // console.log("logiv", index < messages.length - 1 && (messages[index + 1].sender[0]._id !== message.sender_id || messages[index + 1].sender[0]._id === undefined));
  return (
    index < messages.length - 1 &&
    (messages[index + 1].sender[0]._id !== message.sender[0]._id ||
      messages[index + 1].sender[0]._id === undefined) &&
    messages[index].sender[0]._id !== userId
  );
};
export const isLastMessage = (messages, index, userId) => {
  return (
    index === messages.length - 1 &&
    messages[messages.length - 1].sender[0]._id !== userId &&
    messages[messages.length - 1].sender[0]._id
  );
};
export const isSameSenderMargin = (messages, message, index, userId) => {
  if (
    index < messages.length - 1 &&
    messages[index + 1].sender[0]._id === message.sender[0]._id &&
    messages[index].sender[0]._id !== userId
  )
    // return 33;
    return 50;
  else if (
    (index < messages.length - 1 &&
      messages[index + 1].sender[0]._id !== message.sender[0]._id &&
      messages[index].sender[0]._id !== userId) ||
    (index === messages.length - 1 && messages[index].sender[0]._id !== userId)
  )
    return 0;
  else return "auto";
};
// export const isSameUser = (messages, message, index) => {
//   return index > 0 && messages[index - 1].sender_id === message.sender[0]._id;
// };
export const isSameSenderSide = (messages, message, index, userId) => {
  // console.log("sender[0]._id",messages[index].sender[0]._id)
  // console.log("message",message.sender[0]._id)
  if (
    // index < messages.length - 1 &&
    message.sender[0]._id !== userId
    // messages[index + 1].sender[0]._id === message.sender[0]._id &&
    // messages[index].sender[0]._id !== userId
  )
    return "left";
  if (
    // index < messages.length - 1 &&
    message.sender[0]._id === userId
  )
    return "right";
  // else return "auto";
};
export const isSameUser = (messages, message, index, userId) => {
  if (
    index < messages.length - 1 &&
    // messages[index + 1] &&
    message.sender[0]._id === messages[index + 1].sender[0]._id &&
    message.sender[0]._id === userId
  ) {
    return "20px";
  } else if (
    index < messages.length - 1 &&
    // messages[index + 1] &&
    message.sender[0]._id === messages[index + 1].sender[0]._id &&
    message.sender[0]._id !== userId
  ) {
    return "20px";
  } else if (
    index === messages.length - 1 &&
    message.sender[0]._id === userId
  ) {
    return "20px 20px 5px 20px";
  } else if (
    index < messages.length - 1 &&
    message.sender[0]._id === userId &&
    message.sender[0]._id !== messages[index + 1]
    //Use later if needed
    // (message.sender[0]._id !== messages[index + 1] || message.sender[0]._id !== messages[index - 1])
  ) {
    return "20px 20px 5px 20px";
  } else if (
    index === messages.length - 1 &&
    message.sender[0]._id !== userId
  ) {
    return "20px 20px 20px 5px";
  } else if (
    index < messages.length - 1 &&
    message.sender[0]._id !== userId &&
    message.sender[0]._id !== messages[index + 1].sender[0]._id
  ) {
    return "20px 20px 20px 5px";
  }
};
export const otherUserFirstMessage = (messages, message, index, userId) => {
  if (
    message.chat[0].isGroupChat &&
    message.sender[0]._id !== userId &&
    ((index > 0 &&
      message.sender[0]._id !== messages[index - 1].sender[0]._id) ||
      index === 0)
  ) {
    return true;
  } else {
    return false;
  }
};
// export const isSameSender = (messages, message, index, userId) => {
//   console.log("message",message.sender)
//   return (
//     index < messages.length - 1 &&
//     (messages[index + 1].sender[0]._id !== message.sender[0]._id ||
//       messages[index + 1].sender[0]._id === undefined) &&
//     messages[index].sender[0]._id !== userId
//   );
// };
// export const isLastMessage = (messages, index, userId) => {
//   return (
//     index === messages.length - 1 &&
//     messages[messages.length - 1].sender[0]._id !== userId &&
//     messages[messages.length - 1].sender[0]._id
//   );
// };
